declare global {
  interface Window {
    __ZU_PUBLIC_ENV__?: {
      VITE_APP_API_URL?: string;
      VITE_ONLINE_ORDERS_ENABLED?: string;
    };
  }
}

/**
 * `VITE_APP_API_URL` is baked into the bundle at build time via
 * `import.meta.env`, but the value that actually applies per deployment is
 * only known once the container starts (it comes from a Kubernetes Secret
 * sourced from Vault). `window.__ZU_PUBLIC_ENV__` is injected into
 * `index.html` at container start by `scripts/inject-runtime-env.cjs`, so it
 * takes precedence over the build-time default when present.
 */
export const apiUrl =
  (typeof window !== "undefined"
    ? window.__ZU_PUBLIC_ENV__?.VITE_APP_API_URL
    : undefined) ||
  import.meta.env.VITE_APP_API_URL ||
  "https://appointment-springboot.stg.theloop.tech/api";

/**
 * Base URL for the management endpoints: every admin-only route lives under
 * `/api/admin`.
 *
 * Reference data is still read through plain `/api` but written through this
 * base: `/api/refCommunicationTemplates` only exposes GET, while create,
 * update and delete live at `/api/admin/refCommunicationTemplates`.
 */
export const adminUrl = `${apiUrl.replace(/\/$/, "")}/admin`;
